<template>
  <a-row class="content-fix" type="flex">
    <spinner v-if="loading" />
    <a-col v-else class="height100 flex-1">
      <a-tabs :key="$route.fullPath" class="main-tabs" type="card">
        <a-tab-pane key="content">
          <!-- <pre>{{ form }}</pre> -->

          <span slot="tab"> <a-icon type="project" />Содержимое</span>

          <!-- project_name -->
          <a-row align="middle" class="flex-baseline input-form__group">
            <a-col :span="6" style="text-align: right; padding-right: 8px"
              >Название проекта:</a-col
            >
            <a-col :span="12">
              <h3>{{ form.project_name }}</h3>
            </a-col>
          </a-row>

          <!-- organization_name -->
          <a-row align="middle" class="flex-baseline input-form__group">
            <a-col :span="6" style="text-align: right; padding-right: 8px"
              >Название организации:</a-col
            >
            <a-col :span="12">
              <h3>{{ form.organization_name }}</h3>
            </a-col>
          </a-row>

          <!-- leader_employee_name -->
          <a-row align="middle" class="flex-baseline input-form__group">
            <a-col :span="6" style="text-align: right; padding-right: 8px"
              >Имя сотрудника:</a-col
            >
            <a-col :span="12">
              <h3>{{ form.leader_employee_name }}</h3>
            </a-col>
          </a-row>

          <!-- email -->
          <a-row align="middle" class="flex-baseline input-form__group">
            <a-col :span="6" style="text-align: right; padding-right: 8px"
              >E-Mail:</a-col
            >
            <a-col :span="12">
              <h3>{{ form.email }}</h3>
            </a-col>
          </a-row>

          <!-- document_type -->
          <a-row align="middle" class="flex-baseline input-form__group">
            <a-col :span="6" style="text-align: right; padding-right: 8px"
              >Тип документа:</a-col
            >
            <a-col :span="12">
              <h3>{{ form.document_type.name }}</h3>
            </a-col>
          </a-row>

          <!-- document_type -->
          <a-row align="middle" class="flex-baseline input-form__group">
            <a-col :span="6" style="text-align: right; padding-right: 8px"
              >Файлы:</a-col
            >
            <a-col :span="12">
              <a
                v-for="(file, index) in form.files"
                :key="index"
                :href="filesUrl + file.file_name"
                target="blank"
                rel="noreferer noorigin"
              >
                {{ filesUrl + file.file_name }}
              </a>
            </a-col>
          </a-row>
        </a-tab-pane>
      </a-tabs>

      <!-- document_type -->
      <a-row align="middle" class="flex-baseline input-form__group">
        <a-col :span="6" style="text-align: right; padding-right: 8px" />
        <a-col :span="12">
          <a-button @click="$router.go(-1)">Вернуться назад</a-button>
        </a-col>
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
export default {
  data: () => ({
    form: {},
    langTab: $langPrefix,
    loading: false
  }),
  watch: {
    $route: {
      handler: "fetchData",
      immediate: true
    }
  },

  methods: {
    fetchData() {
      if (!this.$route.params.id) return

      this.loading = true

      this.$api
        .get("/request/get/" + this.$route.params.id)
        .then((res) => {
          this.loading = false
          console.log("form-detail", res.data)
          if (res.data) {
            this.form = res.data
          }
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
        })
    }
  }
}
</script>
